// extracted by mini-css-extract-plugin
export default {"greenBadge":"invoice_greenBadge__WH-Bj","dangerBadge":"invoice_dangerBadge__mO8B1","readMore":"invoice_readMore__CsL0A"};